const addDaysISO = (yyyyMmDd, days) => {
  if (!yyyyMmDd) return null;
  const d = new Date(yyyyMmDd);       // "YYYY-MM-DD"
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};

const toYmdCompact = (yyyyMmDd) => (yyyyMmDd || '').replaceAll('-', '');

const joinUrl = (base, path) => {
  const b = (base || '').replace(/\/+$/, '');
  const p = (path || '').replace(/^\/+/, '');
  return `${b}/${p}`;
};

/**
 * Google Calendar URL pro detail soutěže (celodenní událost).
 * @param {Object} event - objekt z detail API (má event_date_start, event_date_end, event_name, id)
 * @param {string} baseUrl - tvůj BaseUrl (např. https://rob-is.cz)
 * @param {string} [detailsPath] - volitelně vlastní cesta, jinak `/soutez/<id>/`
 */
export const buildGoogleCalendarUrlForEvent = (event, baseUrl, detailsPath = null) => {
  const title = event?.event_name || 'Událost';

  const start = event?.event_date_start;
  const endInclusive = event?.event_date_end || start;
  const endExclusive = addDaysISO(endInclusive, 1);

  const dates = `${toYmdCompact(start)}/${toYmdCompact(endExclusive)}`;

  const path = detailsPath ?? (event?.id ? `/soutez/${event.id}/` : '/');
  const detailsUrl = joinUrl(baseUrl, path);

  return (
    `https://calendar.google.com/calendar/render?action=TEMPLATE` +
    `&text=${encodeURIComponent(title)}` +
    `&dates=${dates}` +
    `&details=${encodeURIComponent(detailsUrl)}` +
    `&sf=true&output=xml`
  );
};
